<form [formGroup]="registerForm" (ngSubmit)="restorePassword()">
  <h2 mat-dialog-title>Recuperar contraseña</h2>
  <mat-dialog-content>
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Email</mat-label>
      <input
        formControlName="email"
        matInput
        placeholder="Escriba su email"
        value=""
      />
      <mat-error>{{ getErrorMessageEmail() }}</mat-error>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      type="submit"
      mat-button
      mat-flat-button
      color="primary"
      disabled="{{ this.registerForm.invalid }}"
    >
      Recuperar
    </button>
    <button mat-button mat-dialog-close mat-dialog-close>Cancelar</button>
  </mat-dialog-actions>
</form>
